// hooks/usePlataformasYTecnicos.js
import { useState, useCallback } from "react";
import axios from "../../../config/axiosConfig";

export const usePlataformasYTecnicos = () => {
  const [plataformas, setPlataformas] = useState([]);
  const [tecnicos, setTecnicos] = useState([]);

  const normalizePlataforma = (p) => {
    const id =
      p?.id ??
      p?.id_plataforma ??
      p?.plataforma_id ??
      p?.cod_plataforma ??
      p?.web ??
      p?.codigo;

    return {
      ...p,
      id,
      nombre: p?.nombre ?? p?.descripcion ?? p?.plataforma ?? `Plataforma ${id ?? ""}`,
      url_plataforma: p?.url_plataforma ?? p?.url ?? "",
    };
  };

  const fetchPlataformas = useCallback(async () => {
    try {
      const resp = await axios.get("/api/plataformas");
      const raw = Array.isArray(resp?.data)
        ? resp.data
        : (resp?.data?.body ?? resp?.data?.data?.items ?? resp?.data?.data ?? resp?.data?.items ?? []);
      const activos = (raw || [])
        .map(normalizePlataforma)
        .filter(p => p.id != null && String(p.estado || "Activo").toLowerCase() === "activo")
        .sort((a, b) => (a.nombre || "").localeCompare(b.nombre || "", "es", { sensitivity: "base" }));
      setPlataformas(activos);
    } catch {
      setPlataformas([]);
    }
  }, []);

  const fetchTecnicos = useCallback(async (sucursal) => {
    try {
      const sucursales = String(sucursal || "").trim().toLowerCase() === "la paz"
        ? "La Paz,La Paz(El Alto)"
        : sucursal;
      const resp = await axios.get("/api/usuarios-trs", { params: { role: "tecnico", sucursal: sucursales } });
      const list = (resp?.data ?? [])
        .filter(t => t.estado === "A")
        .sort((a, b) => (a.nombre || "").localeCompare(b.nombre || "", "es", { sensitivity: "base" }));
      setTecnicos(list);
    } catch {
      setTecnicos([]);
    }
  }, []);

  return { plataformas, tecnicos, fetchPlataformas, fetchTecnicos };
};
